import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { constants, getConnectUser } from '../../helpers'
import { sendMessageToWorkerWithResponse } from '../../helpers/communication'
import { VeType, VeVillageType } from '../../storeTypes/vesTypes'

export const getVeAction = createAsyncThunk<
    VeType,
    string,
    { rejectValue: string }
>('ve/getVeAction', async (veZoneCode: string, { rejectWithValue }) => {
    try {
        const { user_id: userId } = getConnectUser()
        const ve = (await sendMessageToWorkerWithResponse({
            [constants.MESSAGES.GET_VE]: { code: veZoneCode, userId }
        })) as VeType
        return ve
    } catch {
        // Surface a generic message; the caller only needs to know it failed.
        return rejectWithValue('Un problème est survenu')
    }
})

type VeStateType = {
    ve: VeType
    selectedVeVillages?: VeVillageType[]
}

const initialState: VeStateType = {
    ve: {} as VeType
}

export const veSlice = createSlice({
    name: 've',
    initialState,
    reducers: {
        resetVeAction: (state) => {
            state.ve = {} as VeType
        },
        selectVeVillageAction: (
            state,
            action: PayloadAction<VeVillageType[]>
        ) => {
            state.selectedVeVillages = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVeAction.fulfilled, (state, action) => {
            state.ve = action.payload
        })
    }
})

export const { resetVeAction, selectVeVillageAction } = veSlice.actions

export default veSlice.reducer
